// This file is automatically compiled by Webpack, along with any other files
// present in this directory. You're encouraged to place your actual application logic in
// a relevant structure within app/javascript and only use these pack files to reference
// that code so it'll be compiled.

import Bugsnag from "@bugsnag/js";
import { bugsnagPrivacyOptions } from "../src/shared/bugsnagPrivacy";
import BugsnagPluginReact from "@bugsnag/plugin-react";
import LocalTime from "local-time";
import { debounce } from "../src/shared/Debounce";
import Alpine from "alpinejs";
import {
  AI_TRIAGE_HOME_HOST_ID,
  MAX_ALPINE_PACK_WAIT_ATTEMPTS,
  shouldWaitForAiTriageHomePack,
} from "../src/aiTriageHomeBoot";
import { define } from "remount";
import { validateComponentProps } from "../src/validateComponentProps";
import { SocialShare } from "../src/SocialShare";
import tracking from "../src/tracking";
import { installHeapDebug } from "../src/heapDebug";
import { startFormSubmitBehaviours } from "../src/formSubmitBehaviours";
startFormSubmitBehaviours();
require("@rails/activestorage").start();
// require('channels');

import { MapboxMap, Props as MapboxMapProps } from "../src/MapboxMap";

// Uncomment to copy all static images under ../images to the output folder and reference
// them with the image_pack_tag helper in views (e.g <%= image_pack_tag 'rails.png' %>)
// or the `imagePath` JavaScript helper below.
require.context("../images", true);

require("../stylesheets/application.scss");

document.addEventListener("DOMContentLoaded", function (event) {
  require("../src/forms");
  tracking();
});

installHeapDebug();

window.Alpine = Alpine;
// The homepage pack is a separate deferred script. If this file runs first,
// wait one macrotask so window.aiTriageHome exists before Alpine walks
// `x-data="aiTriageHome"`. Flag-off pages have no host and start immediately.
const ALPINE_PACK_WAIT_MS = 0;
let alpineStarted = false;
let alpinePackWaitAttempts = 0;

const startAlpine = () => {
  if (alpineStarted) {
    return;
  }
  alpineStarted = true;
  Alpine.start();
};

const startAlpineAfterOptionalPacks = () => {
  const host = document.getElementById(AI_TRIAGE_HOME_HOST_ID);
  const packReady = typeof window.aiTriageHome === "function";
  if (
    shouldWaitForAiTriageHomePack(
      host,
      packReady,
      alpinePackWaitAttempts,
      MAX_ALPINE_PACK_WAIT_ATTEMPTS
    )
  ) {
    alpinePackWaitAttempts += 1;
    window.setTimeout(startAlpineAfterOptionalPacks, ALPINE_PACK_WAIT_MS);
    return;
  }
  startAlpine();
};

if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", startAlpineAfterOptionalPacks);
} else {
  startAlpineAfterOptionalPacks();
}

LocalTime.start();

Bugsnag.start({
  ...bugsnagPrivacyOptions,
  apiKey: window.AppConfig.BUGSNAG_FRONTEND_API_KEY || "invalid",
  plugins: [new BugsnagPluginReact()],
  releaseStage: window.AppConfig.RAILS_ENV,
  enabledReleaseStages: ["production", "staging"],
});

// First we get the viewport height and we multiple it by 1% to get a value for a vh unit
let vh = window.innerHeight;
// Then we set the value in the --vh custom property to the root of the document
document.documentElement.style.setProperty("--vh", `${vh}px`);

// We listen to the resize event
window.addEventListener("resize", () => {
  // We execute the same script as before
  let vh = window.innerHeight;
  debounce(document.documentElement.style.setProperty("--vh", `${vh}px`), 100);
});

document.addEventListener("DOMContentLoaded", () => {
  define({
    "mapbox-map": validateComponentProps(MapboxMapProps.decode, MapboxMap),
    "social-share": SocialShare,
  });
});

import "@hotwired/turbo-rails";
Turbo.session.drive = false;

document.addEventListener("turbo:frame-load", (event) => {
  tracking();

  if (typeof window.Trustpilot !== "undefined") {
    event.target.querySelectorAll(".trustpilot-widget").forEach((widget) => {
      window.Trustpilot.loadFromElement(widget);
    });
  }
});
